import CustomInput from 'Common/CustomInput/CustomInput';
import CustomSelect from 'Common/CustomSelect';
import Show from 'Components/Show/Show';
import React from 'react'
import { FiAlertCircle } from 'react-icons/fi';
import NumberConversion from 'Utils/NumberConversion';
import { calculateCreditCardFee, calculateDiscount, calculateSubtotal, calculateTotalDue, isDiscountExceedingPayment } from 'Utils/Utils';

const PaymentSummary = ({ paymentModel, handlePaymentSummary, lineItems, validationModel }) => {

    const isDiscountExceeding = isDiscountExceedingPayment(paymentModel, lineItems)
    const ccFeePercentage = 2.7;
    return (
        <div className="pt-6 space-y-4 border-t border-slate-200">
            <h3 className="text-sm font-semibold text-slate-900">Summary</h3>
            <div className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-600">Subtotal</span>
                    <span className="font-medium text-slate-900">{NumberConversion(calculateSubtotal(lineItems))}</span>
                </div>

                <div className="flex items-center gap-2">
                    <input type="checkbox" id="isDiscount" checked={paymentModel.isDiscount} onChange={handlePaymentSummary} name="isDiscount" className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" />
                    <label htmlFor="discount" className="text-sm text-slate-600">Add Discount</label>
                    <Show when={paymentModel.isDiscount}>
                        <>
                            <CustomSelect value={paymentModel.discountType} name="discountType" onChange={handlePaymentSummary} wrapperClass=" !ml-auto !w-32"  >
                                <option value="FLAT">Amount</option>
                                <option value="PER">Percentage</option>
                            </CustomSelect>
                            {paymentModel.discountType === 'PER' && <span className="text-lg font-medium text-slate-600">%</span>}
                            {paymentModel.discountType === 'FLAT' && <span className="text-lg font-medium text-slate-600">$</span>}
                            <CustomInput isNumeric isFloat maxFloat={1} value={paymentModel.discountValue} name="discountValue" onChange={handlePaymentSummary} placeholder="0.00" wrapperClass=" !w-20" />

                        </>
                    </Show>
                </div>
                <Show when={paymentModel.isDiscount}>
                    <p className="text-right text-red-500">   {validationModel.discountValueError}</p>
                </Show>

                {paymentModel.isDiscount && (
                    <div className="flex items-center justify-between text-sm text-green-700">
                        <span>Discount Applied</span>
                        <span>-{NumberConversion(calculateDiscount(paymentModel, lineItems))}</span>
                    </div>
                )}
                {paymentModel.isDiscount && isDiscountExceeding && (
                    <div className="flex items-center gap-2 p-3 border border-red-200 rounded-lg bg-red-50">
                        <FiAlertCircle className="flex-shrink-0 w-4 h-4 text-red-600" />
                        <span className="text-sm text-red-700">
                            Discount cannot be higher than the payment amount
                        </span>
                    </div>
                )}

                {(paymentModel.patientPaymentType === 'CC_PMT' || paymentModel.patientPaymentType === 'CC_RDR' || paymentModel.patientPaymentType === 'PAY_REQ') && (
                    <div className="flex items-center gap-2">
                        <input type="checkbox" id="isCCFees" checked={paymentModel.isCCFees} name="isCCFees" onChange={handlePaymentSummary} className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" />
                        <label htmlFor="isCCFees" className="text-sm text-slate-600">
                            Add Credit Card Fee (2.7%)
                        </label>
                        <Show when={paymentModel.isCCFees}>
                            <span className="ml-auto text-sm text-slate-900">
                                {NumberConversion(calculateCreditCardFee(paymentModel, lineItems, ccFeePercentage))}
                            </span>
                        </Show>
                    </div>
                )}
            </div>

            <div className="flex items-center justify-between pt-3 border-t border-slate-200">
                <span className="text-base font-semibold text-slate-900">Total Due</span>
                <span className="text-xl font-bold text-slate-900">{NumberConversion(calculateTotalDue(paymentModel, lineItems))}</span>
            </div>
        </div>
    )
}

export default PaymentSummary